import React, { useState, useRef } from "react";
import { Link, Navigate } from 'react-router-dom';
import { CheckEmail, isAuthenticated } from "../includes/auth";
import { FaEnvelope, FaCheckCircle } from "react-icons/fa";
import { MdEmail, MdArrowForward, MdCancel } from "react-icons/md";
import { BiWorld } from "react-icons/bi";
import logoelakayDiamant from '../includes/Layout/icon/logoelakayDiamant-256.png';
import './user.css';
import AuthPageNav from '../includes/auth/AuthPageNav';
import { elakayAutoText } from "../includes/pageInside/dataElakay";
import { displayAuthError, authErrorMessage } from "../includes/auth/authErrors";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["forgetPassword"]?.[key] || fallback;

const ForgetPassword = (props) => {
    const { 
        infoSource,
        // Animation controls for ForgetPassword page
        enableHeaderAnimations = false,
        enableHeaderShapes = false,
        enableLogoAnimation = false,
        enableLogoPulse = false,
        enableLogoHover = false,
        enableDecorationAnimations = false,
        enableParticles = false,
        particlesCount = 0,
        enableCardEntrance = false,
        enableCardGlow = false,
        enableTitleGlow = false,
        enableIconAnimation = false,
        enableFormGroupFade = false,
        enableInputFocus = false,
        enableButtonHover = false,
        enableButtonIcon = false,
        enableLinkHover = false,
        enableAlertSlide = false,
        enableLoadingDots = false,
        enableSuccessAlert = true,
        enableSuccessIcon = true,
        enableHelpSection = true,
        enableFooterWaves = false,
        enableFooterLinkHover = false
    } = props;
  __setElakayInfoSource(infoSource);
    
    const [values, setValues] = useState({
        email: "",
        error: "",
        errorCode: null,
        message: "",
        success: false,
        loading: false
    });

    const { email, error, message, success, loading } = values;

    const emailRef = useRef(null);
    const scrollToError = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
            ref.current.focus?.();
        }
    };

    const handleChange = name => event => {
        setValues({ ...values, error: false, errorCode: null, success: false, [name]: event.target.value });
    };

    if (isAuthenticated()) {
        return <Navigate to="/" />;
    }

    const clickSubmit = event => {
        event.preventDefault();

        if (!email.trim()) {
            setValues({ ...values, error: "", errorCode: "EMAIL_REQUIRED" });
            scrollToError(emailRef);
            return;
        }

        setValues({ ...values, error: false, errorCode: null, success: false, loading: true });

        CheckEmail({ email })
            .then(data => {
                if (data.error) {
                    setValues({ ...values, error: data.error, errorCode: data.code || null, loading: false });
                } else {
                    setValues({
                        ...values,
                        message: data.message,
                        messageCode: data.code || null,
                        success: true,
                        loading: false
                    });
                }
            });
    };

    const signUpForm = () => (
        <div className={`sign-page-wrapper ${!enableHeaderAnimations ? 'no-animations' : ''}`}>
            {/* Animated Header */}
            <header className={`sign-header ${!enableHeaderAnimations ? 'no-header-animation' : ''}`}>
                {enableHeaderShapes && (
                    <div className="sign-header-bg-shapes">
                        <div className="sign-shape sign-shape-1"></div>
                        <div className="sign-shape sign-shape-2"></div>
                        <div className="sign-shape sign-shape-3"></div>
                        <div className="sign-shape sign-shape-4"></div>
                    </div>
                )}
                
                <div className="sign-header-content">
                    <Link 
                        to="/" 
                        className={`sign-logo ${!enableLogoHover ? 'no-hover' : ''}`}
                    >
                        <div className="sign-logo-icon-wrapper">
                            <img 
                                className={`sign-logo-image ${!enableLogoAnimation ? 'no-bounce' : ''}`}
                                src={logoelakayDiamant} 
                                width="40" 
                                alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).forgetPassword.t001}
                            />
                            {enableLogoPulse && <div className="sign-logo-pulse"></div>}
                        </div>
                        <span className="sign-logo-text">{__elakayText("t008", "elakay")}</span>
                    </Link>
                    
                    <AuthPageNav />
                    {enableDecorationAnimations && (
                        <div className="sign-header-decorations">
                            <BiWorld className="sign-decoration-icon sign-decoration-1" />
                            <div className="sign-decoration-line"></div>
                        </div>
                    )}
                </div>
            </header>

            {/* Main Content */}
            <main className="sign-main-content">
                {enableParticles && (
                    <div className="sign-particles">
                        {[...Array(particlesCount)].map((_, i) => (
                            <div key={i} className="sign-particle" style={{
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 3}s`,
                                animationDuration: `${3 + Math.random() * 2}s`
                            }}></div>
                        ))}
                    </div>
                )}

                <div className="sign-form-container">
                    <div className={`sign-form-card ${!enableCardEntrance ? 'no-entrance' : ''}`}>
                        {enableCardGlow && <div className="sign-form-card-glow"></div>}
                        
                        <form className="sign-form" onSubmit={clickSubmit}>
                            {/* Icon Header */}
                            <div className="sign-form-header">
                                <div className={`sign-verification-icon-wrapper ${!enableIconAnimation ? 'no-animation' : ''}`}>
                                    <div className={`sign-verification-icon-circle ${!enableIconAnimation ? 'no-pulse' : ''}`}>
                                        <FaEnvelope className="sign-verification-icon" />
                                    </div>
                                </div>
                                <h1 className={`sign-form-title ${!enableTitleGlow ? 'no-glow' : ''}`}>
                                    {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).title1 || "Forgot Password?"}
                                </h1>
                                <p className="sign-form-subtitle">{__elakayText("t003", "Enter your email to receive a password reset link")}</p>
                            </div>

                            {showLoading()}
                            {showSuccess()}
                            {showError()}

                            {/* ========== EMAIL INPUT ========== */}
                            <div className={`sign-form-group ${!enableFormGroupFade ? 'no-fade' : ''}`}>
                                <label className="sign-input-label">
                                    {infoSource.laguangeElakay('label', infoSource.languageAPI).email || "Email Address"}
                                    <span style={{ color: 'red' }}> *</span>
                                </label>
                                <div className="sign-input-wrapper">
                                    <div className="sign-input-icon-wrapper">
                                        <MdEmail className={`sign-input-icon ${!enableInputFocus ? 'no-animation' : ''}`} />
                                    </div>
                                    <input
                                        ref={emailRef}
                                        onChange={handleChange("email")}
                                        type="email"
                                        value={email}
                                        name="email"
                                        id="inputEmail"
                                        className={`sign-form-input ${!enableInputFocus ? 'no-focus-animation' : ''}`}
                                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).forgetPassword.t002}
                                        required
                                    />
                                </div>
                                <span className="sign-input-hint">{elakayAutoText("h_forgetpwd_hint_email", "Enter the email address linked to your account — we'll send a reset link there")}</span>
                            </div>

                            <input type="hidden" name="verication" placeholder="" />

                            {/* ========== SUBMIT BUTTON ========== */}
                            <button 
                                type="submit"
                                className={`sign-btn-primary sign-btn-full ${enableButtonIcon ? 'sign-btn-animated' : ''} ${!enableButtonHover ? 'no-hover' : ''}`}
                                disabled={loading}
                            >
                                <span>
                                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).checkEmail || "Send Reset Link"}
                                </span>
                                {enableButtonIcon && <MdArrowForward className="sign-btn-icon" />}
                            </button>

                            {/* ========== CANCEL BUTTON ========== */}
                            <Link 
                                className={`sign-btn-secondary sign-btn-full ${!enableButtonHover ? 'no-hover' : ''}`}
                                to="/signin"
                            >
                                {enableButtonIcon && <MdCancel className="sign-btn-icon" />}
                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).cancel || "Cancel"}
                            </Link>

                            {/* ========== HELPER TEXT ========== */}
                            {enableHelpSection && (
                                <div className="sign-activation-help">
                                    <p className="sign-help-text">{__elakayText("t004", "Remember your password?")}{' '}
                                        <Link 
                                            to="/signin" 
                                            className={`sign-link-primary ${!enableLinkHover ? 'no-hover' : ''}`}
                                        >{__elakayText("t005", "Sign in here")}</Link>
                                    </p>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </main>

            {/* Animated Footer */}
            <footer className={`sign-footer ${!enableFooterWaves ? 'no-waves' : ''}`}>
                {enableFooterWaves && (
                    <div className="sign-footer-waves">
                        <div className="sign-wave sign-wave-1"></div>
                        <div className="sign-wave sign-wave-2"></div>
                        <div className="sign-wave sign-wave-3"></div>
                    </div>
                )}
                
                <div className="sign-footer-content">
                    <p className="sign-footer-text">
                        © {new Date().getFullYear()}{__elakayText("t006", "elakay. All rights reserved.")}</p>
                    <div className="sign-footer-links">
                        <Link 
                            to="/privacy" 
                            className={`sign-footer-link ${!enableFooterLinkHover ? 'no-hover' : ''}`}
                        >{__elakayText("t009", "Privacy")}</Link>
                        <span className="sign-footer-separator">•</span>
                        <Link 
                            to="/terms" 
                            className={`sign-footer-link ${!enableFooterLinkHover ? 'no-hover' : ''}`}
                        >{__elakayText("t010", "Terms")}</Link>
                        <span className="sign-footer-separator">•</span>
                        <Link 
                            to="/help" 
                            className={`sign-footer-link ${!enableFooterLinkHover ? 'no-hover' : ''}`}
                        >{__elakayText("t011", "Help")}</Link>
                    </div>
                </div>
            </footer>
        </div>
    );

    // Re-computed on every render: a language switch re-translates an error
    // already displayed (errorCode + active language), no new request.
    const shownError = displayAuthError(values.errorCode, error);

    const showError = () => (
        <div
            className={`sign-alert sign-alert-danger ${!enableAlertSlide ? 'no-slide' : ''}`}
            style={{ display: shownError ? "" : "none" }}
            role="alert"
        >
            {shownError}
        </div>
    );

    const showSuccess = () => (
        <div
            className={`sign-alert sign-alert-success ${!enableSuccessAlert ? 'no-animation' : ''}`}
            style={{ display: success ? "" : "none" }}
        >
            {enableSuccessIcon && <FaCheckCircle className="sign-alert-icon" />}
            <div>
                <p className="sign-alert-text">
                    {values.messageCode ? authErrorMessage(values.messageCode, message) : message}
                </p>
                <p className="sign-alert-subtitle">{__elakayText("t007", "Please check your email for the password reset link.")}</p>
                <div className="sign-alert-action">
                    <Link to="/signin" className="sign-alert-link">
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).signin || "Back to Sign In"}
                    </Link>
                </div>
            </div>
        </div>
    );

    const showLoading = () =>
        loading && (
            <div className={`sign-alert sign-alert-loading ${!enableAlertSlide ? 'no-slide' : ''}`}>
                {enableLoadingDots && (
                    <div className="sign-loading-dots">
                        <div className="sign-dot"></div>
                        <div className="sign-dot"></div>
                        <div className="sign-dot"></div>
                    </div>
                )}
                <span className="sign-loading-text">
                    {infoSource.language(infoSource, "title", "loanding") || elakayAutoText("h_6abb1a8aff0657", "Sending email...")}
                </span>
            </div>
        );

    return (
        <div className="sign-app-wrapper">
            {signUpForm()}
        </div>
    );
};

export default ForgetPassword;
